// extracted by mini-css-extract-plugin
export default {"button":"button_button__hkamW","button2":"button_button2__JScuH","icon":"button_icon__9wmNa","button1":"button_button1__BP4iQ"};